import React, { Component } from 'react';

// Externals
import classNames from 'classnames';
import PropTypes from 'prop-types';

// Material helpers
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import Popover from '@material-ui/core/Popover';
// Shared components
import Paper from 'components/Paper';
import Portlet from 'components/Portlet';
import PortletHeader from 'components/PortletHeader';
import PortletContent from 'components/PortletContent';
import PortletLabel from 'components/PortletLabel';
import PortletFooter from 'components/PortletFooter';
import Period from '../../../../helpers/PeriodWeighted';
//Components
import ComparativeSpecial from './ComparativeSpecial'
import ObjectiveComparative from './ComparativeObjective'
// Component styles
import styles from './styles';

import moment from 'moment'
import 'moment/locale/es'
moment.locale('es')

class SpecialObjective extends Component {
  constructor(props) {
        
    super(props);
    var isPdf=false
    var dataTypes=(JSON.parse(sessionStorage.getItem("typesSpecial")))
    if(dataTypes.filter(i=>i["content-type"]==="pdf").length>0){
      isPdf=true
    }
    this.state = {
        nameObjective: this.props.data.match.params.nombre_objetivo,
        objective:this.props.data.match.params.objetivo_id,
        method:this.props.method,
        error:false,
        load:false,
        period: "d",
        typePeriod: 1,
        namePeriod: 'Rango: último día',
        statePeriod: {},
        periodEl: null,
        pdf:isPdf
    }
  }

  handlePeriodClick=(prevPeriod, prevTypeGraph, statePeriod, nextPeriod)=> {
    if (nextPeriod === 'dia') {
        this.setState({
            period: "d",
            typePeriod: 1,
            namePeriod: 'Rango: último día',
            statePeriod: {},
            periodEl: null,
        });
    } else if (nextPeriod === '3dia') {
        this.setState({
            period: "3d",
            typePeriod: 5,
            namePeriod: 'Rango: últimos 3 días',
            statePeriod: {},
            periodEl: null,
        });
    } else if (nextPeriod === 'semana') {
        this.setState({
            period: "w",
            typePeriod: 2,
            namePeriod: 'Rango: última semana',
            statePeriod: {},
            periodEl: null,
        });
    } else if (nextPeriod === 'custom') {
        this.setState({
            period: "c",
            typePeriod: 3,
            namePeriod: 'Rango: ' + moment(statePeriod.startDate).format("YYYY-MM-DD") + ' a ' + moment(statePeriod.endDate).add("days", 1).format("YYYY-MM-DD"),
            statePeriod: statePeriod,
            periodEl: null,
        });
    }
  }
  handleShowPeriod = event => {
    this.setState({
        periodEl: event.currentTarget
    });
  };

  handleClosePeriod = () => {
    this.setState({
        periodEl: null
    });
  };

  

  render() {
    const { classes, className, ...rest } = this.props;
    const {periodEl, period, namePeriod, nameObjective, method}=this.state
    const showPeriodEl = Boolean(periodEl);
    return (
      <Portlet
        style={{width:"95%"}}
      >
        <PortletHeader >
          <PortletLabel 
            variant="h6"
            title= {nameObjective}
            style={{ color:'#66788A'}}                                   
          />
           <Button  style={{fontSize:'15px',float:'left', color:'#66788A'}} onClick={this.handleShowPeriod}>
              {namePeriod}<ArrowDropDownIcon />
          </Button>
        </PortletHeader>
        <PortletContent>
          {method=='comparativeObjective'?
          <ObjectiveComparative dataSpecialObjective={this.state}/>
          :
          <ComparativeSpecial dataSpecialObjective={this.state}/>}
          
        </PortletContent>
        <PortletFooter>
         
          <Popover
              anchorEl={periodEl}
              anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'center'
              }}
              onClose={this.handleClosePeriod}
              open={showPeriodEl}
              transformOrigin={{
                  vertical: 'top',
                  horizontal: 'center'
              }}>
              <Period onClick={this.handlePeriodClick} period={period}/>
          </Popover>
        </PortletFooter>
      </Portlet>
    );
  }
}

SpecialObjective.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(SpecialObjective);
